import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RestServiceConstants } from "../../constants/rest-service.constants";
import { RestClient } from "../rest/client/rest.client";
import { ResponseBody } from "../rest/decorators/response-body.decorator";
import { RequestBody, Query } from "../rest/request/params";
import { Headers } from "../rest/decorators/headers.decorator";
import { GET, POST } from "../rest/request/methods";
import { MEGConstants } from "../../constants/meg.constants";
import { MegConfigResponse } from "src/app/models/dmv/meg-config-response";
import { DMVConstants } from "../../constants/dmv.constants";

@Injectable({ providedIn: "root" })
export class MEGDataService extends RestClient {
	@Headers({
		Accept: RestServiceConstants.APPLICATION_JSON,
		"content-type": RestServiceConstants.APPLICATION_JSON
	})
	@GET()
	@ResponseBody<MegConfigResponse>()
	public getConfiguration(
		@Query("AppTypeID") appType?: number,
		@Query("EntryPointID") entryPointID?: number,
		@Query("Token") token?: string
	): Observable<MegConfigResponse> {
		return;
	}

	public getConfigurationResponse(
		appType: number,
		entryPointID: number,
		token?: string
	): Observable<MegConfigResponse> {
		this.setDynamicTimeout(DMVConstants.TIMEOUT);
		this.setDynamicUri(MEGConstants.CONFIGURATION_URI);

		return this.getConfiguration(appType, entryPointID, token);
	}
}
